import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';

import { CompanyProfile, UsersService, EditCompanyProfile } from 'src/app/services/bdoservice/users/users.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-company-profile-card',
  templateUrl: './edit-company-profile-card.component.html',
  standalone: false

})
export class EditCompanyProfileCardComponent implements OnInit {

  form: FormGroup;
  editProfileError = '';

  @Input()
  companyProfile: CompanyProfile

  saving = false;

  private readonly usersService = inject(UsersService);
  private readonly messageService = inject(MessageService);
  private readonly translate: TranslateService = inject(TranslateService);


  ngOnInit(): void {
    this.form = new FormGroup({
      firstName: new FormControl(this.companyProfile?.firstName || '', Validators.required),
      lastName: new FormControl(this.companyProfile?.lastName || '', Validators.required),
      email: new FormControl({value: this.companyProfile?.username || '', disabled: true}),
      companyName: new FormControl(this.companyProfile?.companyName || '', Validators.required),
      marketingAgreement: new FormControl(this.companyProfile?.marketingAgreement || false)
    });
  }

  submitProfile(){
    // Oznacz wszystkie pola jako touched aby pokazać błędy walidacji
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].markAsTouched();
    });

    // Jeśli formularz nie jest prawidłowy, nie kontynuuj
    if (!this.form.valid) {
      return;
    }

    this.editProfileError = '';
    this.saving = true;
    const formValue = this.form.value
    const request = new EditCompanyProfile(formValue.firstName, formValue.lastName, formValue.companyName, formValue.marketingAgreement)

    this.usersService.editCompanyProfile(request).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('profile.edit.messages.success'),
        detail: this.translate.instant('profile.edit.messages.profileUpdated')
      });
    }).catch(err => {
      this.editProfileError = err.console.error;
    }).finally(() => {
      this.saving = false;
    });
  }

  getError(controlName: string): string {
    const control = this.form.controls[controlName];
    if(control.errors?.required){
      return this.translate.instant('profile.edit.validation.required');
    }
    return '';
  }
}
